import gql from 'graphql-tag';

const WEBSITE_LOGIN = gql`
    mutation websiteLogin($email: String!, $password: String!) {
        websiteLogin(email: $email, password: $password) {
        user {
            id
            email
            fullName
            accountStatus
            mobile
            uberProfileImage
            city {
                name
            }
        }
        adminUser {
            id
            email
            fullName
        }
        token
        error
        }
    }
`

export {WEBSITE_LOGIN};


// WEBPACK FOOTER //
// ./src/components/NewSignIn/queries.js